import React, { useContext, useState } from 'react'
import ClassNames from 'classnames'
import Button from 'Molecules/Button'
import Typography from 'Atoms/Typography'
import TextLink from 'Atoms/TextLink'
import List from 'Molecules/List'
import Divider from 'Atoms/Divider'
import YourVehicles from '../YourVehicles'

import { VehicleContext } from 'Contexts/VehicleContext'
import { UserContext } from 'Contexts/UserContext/UserContext'
import { NavigationContext } from 'Contexts/Navigation/NavigationContext'

import garageStyles from './GarageDropdown.module.scss'
import { addAVehicleEvent, viewGarageEvent } from '../../../../Utilities/Instrumentation/Fitment/fitmentGaEvents'

const GarageDropdown = ({ services, ...props }) => {
    try {
        const [showAllVehicles, setShowAllVehicles] = useState(false)
        const { context: vehicleState } = useContext(VehicleContext)
        const { context: userState } = useContext(UserContext)
        const { userGuid } = userState

        const { setYmmModal: setModal, dispatch: navigationDispatch, state: navigationState } = useContext(NavigationContext)


        const totalCustomerVehicles = vehicleState?.customerVehicles
            ? vehicleState.customerVehicles.length
            : 0

        return (

            <div
                className={ClassNames(
                    garageStyles.garageContainer,
                    totalCustomerVehicles > 0
                        ? garageStyles.garageContainerWithVehicles
                        : false
                )}
            >
                <GarageDropdownHeading vehicleTotal={totalCustomerVehicles} />
                <YourVehicles
                    userGuid={userGuid}
                    services={services}
                    showAllVehicles={showAllVehicles}
                />
                {totalCustomerVehicles > 0 ? (
                    <List
                        itemLayout="horizontal"
                        className={garageStyles.dropdownLinks}
                    >
                        <ShowAllVehicles
                            showAllVehicles={showAllVehicles}
                            setShowAllVehicles={setShowAllVehicles}
                        />
                        <ClearSelection />
                    </List>
                ) : (
                    false
                )}


                <Button
                    intent={'action'}
                    size={'small'}
                    onClick={(event) => {
                        event.stopPropagation()
                        setModal(true)

                    }}
                    gaEvent={addAVehicleEvent}
                    testingName={'Add a Vehicle'}
                    type={'button'}
                    text={'Add a Vehicle'}
                    className={garageStyles.addVehicleButton}
                    fill
                />

                {totalCustomerVehicles > 0 ? (
                    <Button
                        intent={'action'}
                        invert
                        href={'/CustomerVehicle'}
                        size={'small'}
                        event={viewGarageEvent}
                        type={'button'}
                        testingName={'View your Garage'}
                        text={'View your Garage'}
                        className={garageStyles.garageButton}
                        fill
                    />
                ) : (
                    false
                )}
            </div>
        )
    } catch (e) {
        console.error(e)
        return false
    }
}
const GarageDropdownHeading = ({ vehicleTotal }) => {
    const headingText =
        vehicleTotal > 0 ? `Your Vehicles (${vehicleTotal})` : 'Add a Vehicle'

    return (
        <>
            <Typography
                className={garageStyles.garageHeading}
                tone={'normal'}
                size={1.25}
                font={'heading'}
            >
                {headingText}
            </Typography>
            <Divider
                className={garageStyles.garageDivider}
                tone={'superfluous'}
            />
            {vehicleTotal == 0 ? (
                <div className={garageStyles.garageFlavorText}>
                    <Typography tone={'normal'} size={1} font={'regular'}>
                        Store vehicles in your garage to easily find parts,
                        accessories and personalized recommendations.
                    </Typography>
                </div>
            ) : (
                false
            )}
        </>
    )
}

const ClearSelection = ({ }) => {
    const { context: vehicleState, ClearSelectedVehicle } = useContext(
        VehicleContext
    )
    let selectedVehicle = getSelectedVehicleToClear(
        vehicleState.selectedVehicle
    )
    if (!selectedVehicle) return false

    return (
        <TextLink
            intent={'action'}
            onClick={async () => {
                ClearSelectedVehicle('/')
            }}
            underlineHover
        >
            Clear Selection
        </TextLink>
    )
}
const ShowAllVehicles = ({ setShowAllVehicles, showAllVehicles }) => {
    const { context } = useContext(VehicleContext)

    let buttonText = ''
    if (!context.customerVehicles || context?.customerVehicles?.length <= 3) {
        return false
    }

    if (showAllVehicles) {
        buttonText = 'Hide Vehicles'
    } else {
        buttonText = `Show all Vehicles`
    }

    return (
        <TextLink
            intent={'action'}
            onClick={() => {
                setShowAllVehicles(!showAllVehicles)
            }}
            underlineHover
        >
            {buttonText}
        </TextLink>
    )
}

function getSelectedVehicleToClear(selectedVehicle) {
    if (!selectedVehicle) return false
    if (selectedVehicle.shopUrl && selectedVehicle.raceDisplay) {
        return {
            displayName: selectedVehicle.raceDisplay,
            shopUrl: selectedVehicle.shopUrl
        }
    } else if (
        selectedVehicle.shopUrl &&
        selectedVehicle.yearId &&
        selectedVehicle.modelDisplay
    ) {
        let year = selectedVehicle.yearId.toString().substr(2)
        return {
            displayName: `${year} ${selectedVehicle.modelDisplay}`,
            shopUrl: selectedVehicle.shopUrl
        }
    }
    return false
}

export default GarageDropdown
